<template>
    <div v-if="leases.selectedLease" class="lease-usage">
        <div v-if="showUnallocatedError" class="lease-usage__alert">
            Unallocated square footage cannot be less than zero
        </div>
        
        <div class="lease-usage__grid-2">
            <div class="lease-usage__card">
                <div class="lease-usage__card-value">{{ leases.selectedLease.total_square_feet | number }}</div>
                <div class="lease-usage__card-label">Total Square Footage</div>
            </div>

            <div class="lease-usage__card">
                <div class="lease-usage__card-value">{{ unallocatedSquareFootage | number }}</div>
                <div class="lease-usage__card-label">Unallocated Square Footage</div>
            </div>
        </div>

        <div class="lease-usage__grid-3" :class="{ 'lease-usage__grid-3--single': fromReatlas }">
            <div class="lease-usage__space-card">
                <div class="lease-usage__space-header">
                    <div class="lease-usage__space-title">
                        <span>Office Space</span>
                        <InfoIcon identifier="sites-usage-officespace" />
                    </div>
                    <div class="lease-usage__space-percentage">{{ leases.selectedLease.office_percentage }}%</div>
                </div>
                
                <input 
                    @change="save" 
                    v-model.number="leases.selectedLease.office_percentage" 
                    type="range" 
                    min="0" 
                    max="100" 
                    step="5" 
                    class="lease-usage__range"
                >
                
                <div class="lease-usage__space-footer">
                    <span class="lease-usage__space-value">{{ calculateSquareFootage(leases.selectedLease.office_percentage) | number }}</span>
                    <span class="lease-usage__space-unit">Square Feet</span>
                </div>
            </div>

            <div 
                v-if="['Industrial', 'Flex'].includes(sites.selectedSite.building.type.type)" 
                class="lease-usage__space-card lease-usage__space-card--industrial"
            >
                <div class="lease-usage__space-header">
                    <div class="lease-usage__space-title">
                        <span>Industrial Space</span>
                        <InfoIcon identifier="sites-usage-industrialspace" />
                    </div>
                    <div class="lease-usage__space-percentage">{{ leases.selectedLease.industrial_percentage }}%</div>
                </div>
                
                <input 
                    @change="save" 
                    v-model.number="leases.selectedLease.industrial_percentage" 
                    type="range" 
                    min="0" 
                    max="100" 
                    step="5" 
                    class="lease-usage__range"
                >
                
                <div class="lease-usage__space-footer">
                    <span class="lease-usage__space-value">{{ calculateSquareFootage(leases.selectedLease.industrial_percentage) | number }}</span>
                    <span class="lease-usage__space-unit">Square Feet</span>
                </div>
            </div>

            <div 
                v-if="['Industrial', 'Flex'].includes(sites.selectedSite.building.type.type)" 
                class="lease-usage__space-card lease-usage__space-card--manufacturing"
            >
                <div class="lease-usage__space-header">
                    <div class="lease-usage__space-title">
                        <span>Manufacturing Space</span>
                        <InfoIcon identifier="sites-usage-manufacturingspace" />
                    </div>
                    <div class="lease-usage__space-percentage">{{ leases.selectedLease.manufacturing_percentage }}%</div>
                </div>
                
                <input 
                    @change="save" 
                    v-model.number="leases.selectedLease.manufacturing_percentage" 
                    type="range" 
                    min="0" 
                    max="100" 
                    step="5" 
                    class="lease-usage__range"
                >
                
                <div class="lease-usage__space-footer">
                    <span class="lease-usage__space-value">{{ calculateSquareFootage(leases.selectedLease.manufacturing_percentage) | number }}</span>
                    <span class="lease-usage__space-unit">Square Feet</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            formErrors: {
                type: [String, Object],
                required: false
            },

            fromReatlas: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                loading: false,
                showUnallocatedError: false
            }
        },

        computed: {
            ...mapState(['leases']),
            ...mapState(['sites']),

            unallocatedSquareFootage() {
                if (this.leases.selectedLease.office_percentage + this.leases.selectedLease.industrial_percentage + this.leases.selectedLease.manufacturing_percentage == 100) {
                    return 0;
                }

                var unallocatedSquareFootage = this.leases.selectedLease.total_square_feet - this.calculateSquareFootage(this.leases.selectedLease.office_percentage) - this.calculateSquareFootage(this.leases.selectedLease.industrial_percentage) - this.calculateSquareFootage(this.leases.selectedLease.manufacturing_percentage);

                return (isNaN(unallocatedSquareFootage) ? 0 : unallocatedSquareFootage);
            },

            isValidAllocation() {
                if (this.leases.selectedLease.office_percentage + this.leases.selectedLease.industrial_percentage + this.leases.selectedLease.manufacturing_percentage <= 100) {
                    return true;
                }

                return false;
            },

            errors() {
                return this.formErrors;
            }
        },

        methods: {
            calculateSquareFootage(percentage) {
                var sqFt = parseInt(this.leases.selectedLease.total_square_feet * (percentage / 100));

                return (isNaN(sqFt) ? 0 : sqFt);
            },

            save() {
                this.showUnallocatedError = false;
                
                if (this.unallocatedSquareFootage < 0) {
                    this.showUnallocatedError = true;
                    return;
                }

                this.loading = true;
                
                axios.patch('/leases/' + this.leases.selectedLease.id, this.leases.selectedLease).then((response) => {
                    this.leases.selectedLease = response.data.lease || this.leases.selectedLease;

                    this.$emit('leaseSaved', response.data.lease ? response.data.lease.id : this.selectedLeaseId);
                    this.$emit('updateUtilization', response.data.lease.site);

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });
                }).catch((error) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response.data.message
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
